<div class="howToBuy_container">
    <img src="{{howToBuy.icon.src}}" alt="{{howToBuy.icon.alt}}">
    <h2>{{howToBuy.title}}</h2>
    <p>{{howToBuy.text}}</p>
</div>
